<section class="mat-typography heading center">
  <br />
  <h1>APN Usage Report</h1>
</section>
@if (!loading) {
<div class="form-group padded-side-nav">
  <br />
  @if (!resetHeader) {
<div class="search-bar">
    <app-generic-table-header
      [config]="headerOptions"
      (dropdownSelected)="groupSelect($event)"
      (viewPressed)="EnquireReportInfo()"
      (exportPressed)="downloadReport()"
      (clearPressed)="reset()"
      (selectAllPressed)="selectAll($event)"
      (dateRangeChange)="setDate($event)"></app-generic-table-header>
  </div>
}
  @if (!resetHeader) {
<div class="instructions mat-typography">
    Select a date range and group followed by a list of APN(s) to begin report
    generation.
  </div>
}
  @if (showAPNTable) {
<div class="apns-table">
    <ng-template
      #prefixTemplate
      let-row>
      <app-card-table-actions
        [row]="row"
        (actionEvent)="selectionMade($event)"
        [breakpoint]="ScreenSize.TABLET"
        [makeCheckbox]="true">
      </app-card-table-actions>
    </ng-template>
    @if (!resetting && apns.length >0) {
<app-card-table
      [data]="apns"
      [tableHeaders]="headers"
      [options]="options"
     
      [enableInfiteScroll]="false"
      [prefixTemplate]="prefixTemplate"
      [enableTablePagination]="true"
      [enableRefresher]="false"
      [totalItems]="apns.length"
      [currentPage]="currentPage"
      (paginateEvent)="onPageChange($event)"
      [breakpoint]="ScreenSize.TABLET"
      (rowSelectedEvent)="selectionMade($event)"></app-card-table>
}
  </div>
}

  @if (!loading && reportResults != null && reportResults.length > 0) {
<div>
    <div class="heading mat-typography">
      Results
    </div>
    <app-card-table
      [data]="reportResults"
      [tableHeaders]="resultsHeaders"
      [options]="resultOptions"
      [enableInfiteScroll]="false"
      [enableTablePagination]="true"
      [enableRefresher]="false"
      [totalItems]="reportResults.length"
      [currentPage]="resultsCurrentPage"
      (paginateEvent)="onPageChangeResult($event)"
      [breakpoint]="ScreenSize.TABLET">
    </app-card-table>
  </div>
}
</div>
}
@if (loading) {
<div class="flex-center">
  <mat-spinner></mat-spinner>
</div>
}